import SharedHeader from '@/components/share/header'
import SharedFooter from '@/components/share/footer'
import Terms from '@/components/share/terms'
const Validator = require('validatorjs')
Validator.useLang('ja')

export default {
  name: 'step-2',
  components: {
    SharedHeader,
    SharedFooter,
    Terms
  },
  computed: {
    user () {
      return this.$store.getters.user
    },
    api () {
      return this.$store.getters.api
    }
  },
  data () {
    return {
      updating: false,
      error: {},
      isAlert: false,
      state: {},
      isAgree: false,
      trigger: [],
      triggerOptions: [
        { value: 1, text: 'Twitter' },
        { value: 2, text: 'Facebook' },
        { value: 3, text: 'プレスリリースをみて' },
        { value: 4, text: 'チラシをみて' },
        { value: 6, text: 'Google検索' },
        { value: 7, text: 'Yahoo検索' },
        { value: 8, text: 'Bing検索' },
        { value: 9, text: 'Web上の記事等をみて' },
        { value: 10, text: '知人の紹介' },
        { value: 11, text: 'その他' }
      ],
      objective: [],
      objectiveOptions: [
        { value: 1, text: '新卒採用の一環として' },
        { value: 2, text: '学生への認知拡大' },
        { value: 3, text: '長期インターン採用' },
        { value: 4, text: '短期インターン採用' },
        { value: 5, text: 'イベント等への誘致' }
      ]
    }
  },
  methods: {
    updateRegister () {
      this.updating = true

      if (!this.isAgree) {
        this.error.message = '利用規約に同意してください'
        this.isAlert = true
        window.scrollTo(0, 0)
        this.updating = false
      } else {
        this.isAlert = false

        let additionalParams = {
          queryParams: {
            type: 'terms'
          }
        }

        let body = {
          trigger: this.trigger,
          objective: this.objective
        }

        this.$apig.patch(this.api.ENTERPRISE, {}, additionalParams, body)
          .then(response => {
            this.$router.push('/register/complete')
          })
          .catch(err => {
            this.error = err.response.data
            this.isAlert = true
            window.scrollTo(0, 0)
            this.updating = false
          })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/register/step-2/step-2.js